<template>
  <div id="app">
    <Listing />
  </div>
</template>

<script>
import Listing from './components/Listing.vue'

export default {
  name: 'app',
  components: {
    Listing
  }
}
</script>

<style>

</style>
